import { observer } from 'mobx-react-lite';
import React, { useMemo } from 'react';
import { Option } from './Option';
import { Text } from './Text';
import Asterisk from '../../components/Asterisk/Asterisk';
import cx from 'classnames';

// interface IQuestionProps {
//   settings: any;
//   environment: any;
//   questions: any;
//   validations: any;
//   contentModuleId: any;
//   contentLayoutModuleId: any;
// }

export const Question = observer(props => {
  const { settings, environment, questions, validations, contentModuleId } = props;
  const { questionId, prefixClassName, type, hidden, imitateField } = settings;

  const question = useMemo(() => questions.find(q => q.questionId === questionId), [questions, questionId]);
  const label = useMemo(() => question?.questionLanguage?.find(fl => fl.languageCode === environment.lang)?.label, [question, environment.lang]);
  const subLabel = useMemo(() => question?.questionLanguage?.find(fl => fl.languageCode === environment.lang)?.subLabel, [question, environment.lang]);
  const validity = useMemo(() => validations.find(v => v.id === contentModuleId), [validations]);
  const required = useMemo(() => question?.requiredMin > 0 || settings?.required, [question, settings?.required]);

  if (!question || hidden) return null;
  if (type?.toLowerCase() === 'option') {
    return (
      <div className={`${imitateField ? 'cms-field' : prefixClassName} form-group `} style={{ alignItems: 'start' }}>
        <div className="title-holder">
          <label className={cx(prefixClassName, 'mr-2')}>
            {!settings?.hideLabel && label}
            {required && <Asterisk />}
          </label>
          {subLabel ? <label className="sublabel">{subLabel}</label> : null}
        </div>
        <Option {...{ ...props, question, validity }} />
      </div>
    );
  }
  return <Text {...{ ...props, validity, label, question, subLabel }} />;
});
